module.exports = __webpack_public_path__ + "img/AL12X1-1-EN.3259e730.png";